import React from 'react'
import AppRouter from "./routes/index";
import { Toaster } from 'react-hot-toast';

import { Provider } from 'react-redux';
import configureStore from './store/';

import './styles/index.css';
import './styles/index.scss';
import './styles/menu.css'
import './styles/menu.scss'

const store = configureStore();

function App() {

  return (

    <Provider store={store}>
      <div className="">
        <AppRouter />
        <Toaster position="top-right" reverseOrder={true} />
      </div>
    </Provider>
  );
}

export default App;
